import React, { useState, useEffect, useCallback } from "react";

export default function DateInput({
  value,
  onChange,
  onValidityChange,
  ...props
}) {
  const [inputValue, setInputValue] = useState(value || "");
  const [isValid, setIsValid] = useState(true);
  const [placeholder, setPlaceholder] = useState("ДД.ММ.ГГГГ");

  // ✅ Валидация даты + запрет прошлого
  const validateDate = useCallback(
    (val) => {
      const regex = /^(\d{2})\.(\d{2})\.(\d{4})$/;
      if (regex.test(val)) {
        const [, dd, mm, yyyy] = val.match(regex);
        const date = new Date(`${yyyy}-${mm}-${dd}`);
        const isValidDate =
          date.getDate() === parseInt(dd) &&
          date.getMonth() + 1 === parseInt(mm) &&
          date.getFullYear() === parseInt(yyyy);

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const notInPast = date >= today;

        const valid = isValidDate && notInPast;
        setIsValid(valid);
        onValidityChange(valid);
      } else {
        setIsValid(false);
        onValidityChange(false);
      }
    },
    [onValidityChange]
  );

  useEffect(() => {
    validateDate(inputValue);
  }, [inputValue, validateDate]);

  // ✅ Автоформатирование при вводе
  const formatDate = (val) => {
    let digits = val.replace(/\D/g, "");
    if (digits.length > 8) digits = digits.slice(0, 8);

    if (digits.length > 4) {
      return `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4)}`;
    } else if (digits.length > 2) {
      return `${digits.slice(0, 2)}.${digits.slice(2)}`;
    }
    return digits;
  };

  const handleChange = (e) => {
    const formatted = formatDate(e.target.value);
    setInputValue(formatted);
    onChange({ target: { name: props.name, value: formatted } });
  };

  const handleFocus = () => {
    setPlaceholder("Укажите желаемую дату приема");
  };

  const handleBlur = () => {
    setPlaceholder("ДД.ММ.ГГГГ");

    if (/^\d{1,2}$/.test(inputValue)) {
      const day = parseInt(inputValue, 10);
      const today = new Date();

      let targetMonth = today.getMonth();
      let targetYear = today.getFullYear();

      if (day < today.getDate()) {
        targetMonth += 1;
        if (targetMonth > 11) {
          targetMonth = 0;
          targetYear += 1;
        }
      }

      const date = new Date(targetYear, targetMonth, day);
      const formatted = date.toLocaleDateString("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

      setInputValue(formatted);
      onChange({ target: { name: props.name, value: formatted } });
    }
  };

  return (
    <input
      {...props}
      type="text"
      placeholder={placeholder}
      value={inputValue}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      className={`${props.className || ""} ${
        !isValid && inputValue ? "invalid" : ""
      }`}
    />
  );
}
